<script lang="ts">
	import { fade } from 'svelte/transition';
	import ProgressIndicator from '$lib/elements/ProgressIndicator.svelte';
</script>

<div
	in:fade|global={{ duration: 300 }}
	out:fade|global={{ duration: 300 }}
	class="fixed top-0 z-preloading-spinner h-screen w-full flex items-center justify-center bg-white bg-opacity-50 backdrop-filter backdrop-blur firefox:bg-opacity-90"
>
	<ProgressIndicator appearance="circular" size="huge" />
</div>
